import React, { Component } from 'react'
import cx from 'classnames'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

import collectionChangeHandler from '../../helpers/collection-change-handler'

import {
  CollectionButton
} from '../buttons'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

class WorkSummaryAddServices extends Component {
  checkboxes (resources) {
    const {
      fields: {
        serviceIds
      },
      servicing: { services = [] } = {},
    } = this.props

    return (
      <div>
        {resources.map((resource, index) => {
          if (!resource) return null
          const disabled = services.indexOf(resource.id) >= 0

          return (
            <label htmlFor={resource.id} key={resource.id} className={cx({ disabled })}>
              <input
                type='checkbox'
                value={resource.id}
                id={resource.id}
                checked={(serviceIds.value && serviceIds.value.indexOf(resource.id) >= 0)}
                onChange={collectionChangeHandler(serviceIds)}
                disabled={disabled}
              />
              <span className='indicator' />
              {resource.name}
            </label>
          )
        })}
      </div>
    )
  }

  render () {
    const {
      fields: {
        serviceIds
      },

      services,

      handleSubmit,
      handleClose,
      modalTitle,
      submitButtonText,

      hasNextPage,
      onLoadNextPage
    } = this.props

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='work-orders-create-container'
      >
        <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
          <ModalFormRow>
            <ModalFormBlock>
              <CheckboxGroup title='Services'>
                {services && this.checkboxes(services)}
                {services && services.length === 0 &&
                  <p className='none'>No Services found.</p>}
              </CheckboxGroup>
            </ModalFormBlock>
          </ModalFormRow>

          {hasNextPage &&
            <CollectionButton onClick={onLoadNextPage}>See more services...</CollectionButton>}

          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type='submit'>{submitButtonText || 'Submit'}</button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </BaseModal>
    )
  }
}

function formatResourceName (resource, resourceNameGenerator) {
  if (resourceNameGenerator) {
    return resourceNameGenerator(resource)
  } else {
    return resource.name
  }
}

export default WorkSummaryAddServices



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-add-services.js